// src/components/gallery/PhotoList.jsx
import { Heart, Eye, Download } from "lucide-react";

const PhotoList = ({ photos, onPhotoClick }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Photo</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Size</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Upload Date</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Engagement</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {photos.map((photo,idx) => (
              <tr key={idx} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <img
                      src={photo?.url}
                      alt={photo?.title}
                      loading="lazy"
                      className="h-16 w-16 rounded-lg object-cover"
                    />
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900">{photo?.title}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 text-sm text-gray-500">{photo?.size}</td>
                <td className="px-6 py-4 text-sm text-gray-500">{photo?.uploadDate}</td>
                <td className="px-6 py-4 text-sm text-gray-500">
                  <div className="flex items-center space-x-4">
                    <span className="flex items-center"><Heart className="h-4 w-4 mr-1" />{photo.likes}</span>
                    <span className="flex items-center"><Eye className="h-4 w-4 mr-1" />{photo.views}</span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <button
                    onClick={() => onPhotoClick(photo)}
                    className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors mr-2"
                  >
                    <Eye className="h-4 w-4" />
                  </button>
                  <button className="p-2 text-emerald-600 hover:bg-emerald-50 rounded-lg transition-colors">
                    <Download className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PhotoList;
